import { Card, Radio, Switch } from "antd";
import { useState } from 'react'
import { useAuth } from '../../../../store/AuthContext/AuthContext';
import { useFetch } from "../../../../hooks/useFetch/useFetch";
import { useTranslation } from 'react-i18next';
import './LocationsSummary.css';
import { SpinLZ } from "../../../components/design/Spinner/SpinLZ";
import { Synchronized } from "../../../components/design/Synchronized/Synchronized";
import { SCHEDULEDJOB } from "../../../../common/constants/services";
import { BlockInfoKpis } from "../blocks/BlockInfoKpis";
import { BlockConversion } from "../blocks/BlockConversion";
import SelectMonthPeriod from "../../../components/model/selectMonths/SelectMonthPeriod";
import { PageTitle } from "../../common/PageTitle";
import { PageFilters, PageFilterField } from "../../common/PageFilters";

export const LocationsSummary = () => {
    // @Deprecated ????????
    const { projectGroup } = useAuth();

    const [isLoading, setIsLoading] = useState(true);    
    const [conversionData, setConversionData] = useState<any>();    
    const [selectedType, setSelectedType] = useState('LAST_6MONTHS');        

    const { t } = useTranslation();

    useFetch(`${process.env.REACT_APP_API}/projects/` + projectGroup.project + '/' + projectGroup.group + '/summary/info/locations?periodOpt=' + selectedType, {}, [],
        (data: any) => {
            setConversionData(data);            
            //setKpis(data.kpis);
            setIsLoading(false);
        });

    return (
        <div>
            <Card className='main-card-content' id='element-to-capture'>

                    <Synchronized service={[SCHEDULEDJOB.GBP_LOCATIONS]}/>	
                    
                    <div style={{display:'flex', color:'slategray', justifyContent:'space-between', alignItems:'center'}}>
                        <PageTitle
                            title='Métricas de Rendimiento'
                            pageInfo='Visualiza el rendimiento de tus fichas de negocio: impresiones, acciones de cliente y evolución en el periodo seleccionado para entender el volumen real de tráfico que tu presencia digital está derivando a tu local.'
                            extra={
                                <PageFilters>
                                    <PageFilterField label='Periodo'>
                                        <SelectMonthPeriod setSelectedType={setSelectedType} defaultValue='LAST_6MONTHS'/>
                                    </PageFilterField>
                                </PageFilters>
                            }
                        />
                    </div>                    
                    {isLoading ? <SpinLZ /> : <div className="card-container" style={{ marginTop: 14, padding: '6px 0 0' }}>
                    <BlockConversion data={conversionData} selectedType={selectedType}/>
                </div>
                }
            </Card>
        </div>
    )
}